import "./SuggestionList.scss";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import classNames from "classnames";
import Button from "../../Button/Button";

export const SuggestionList = forwardRef((props, ref) => {
    const [selectedIndex, setSelectedIndex] = useState(0);
    const items = props.items ?? [];

    useEffect(() => {
        setSelectedIndex(0)
    }, [items]);

    useImperativeHandle(ref, () => ({
        onKeyDown: (event) => {
            if (event.key === "ArrowUp") {
                setSelectedIndex(i => (i + items.length - 1) % items.length)
                return true
            }
            if (event.key === "ArrowDown") {
                setSelectedIndex(i => (i + 1) % items.length)
                return true
            }
            if (event.key === "Enter") {
                props.command(items[selectedIndex])
                return true
            }
            return false
        },
    }))

    if (!items.length) return null

    return (
        <div className={classNames("suggestion-list", props.className)}>
            {items.map((item, index) => (
                <Button
                    className={classNames("suggestion-item", {selected: index === selectedIndex})}
                    key={item.label ?? item}
                    onClick={() => props.command(item)}
                    onMouseEnter={() => setSelectedIndex(index)}
                >
                    @{item.label ?? item}
                </Button>
            ))}
        </div>
    )
})
